import { DatePipe } from "@angular/common";
import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import * as moment from "moment";
import { Observable } from "rxjs";
import { DteEmitido } from "src/app/models/Dte/DteEmitido";
import { DteRecibido } from "src/app/models/Dte/DteRecibido";
import { FacturaExportacion } from "src/app/models/Dte/FacturaExportacion";
import { IDte } from "src/app/models/Dte/IDte";
import { RespuestaEstadoDte } from "src/app/models/Dte/RespuestaEstadoDte";
import { Emisor } from "src/app/models/Emisor/Emisor";
import { TipoDte } from "src/app/models/tipoDte";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { Page } from "src/app/shared/models/Page";
import { DteEmitidosService } from 'src/app/services/dte-emitidos.service';
import { DteFilter } from 'src/app/models/Dte/DteFilter';
import * as FileSaver from 'file-saver';
import Swal from 'sweetalert2';
import { TokenStorageService } from "src/app/services/token-storage.service";
@Component({
	selector: "app-export-modal",
	templateUrl: "./export-modal.component.html",
	styleUrls: ["./export-modal.component.scss"],
})
export class ExportModalComponent implements OnInit {
	@Output() exportData = new EventEmitter<boolean>();
	@Input() locale: any;
	@Input() filter: any;
	@Input() encabezados: any;
	@Input() type: number;
	@Input() getDataFunction: (filter: any) => Observable<any>;
	@Input() getPagedDataFunction: (filter: any, totalEments: number) => Observable<any>;
	@Input() totalItems: number;
	validDate: boolean = true;
	public exportType: string = 'excel';
	public empresasSource: Emisor[];
	public tipoDteSource: TipoDte[];
	public isSuperAdmin: boolean = this.tokenService.getUser().superAdmin;
	private currentUsuarioId = this.tokenService.getUser().id;
	public dateExportacion: any = { startDate: null, endDate: null };
	public todayString = moment();
	public minDate: moment.Moment;
	public maxDate: moment.Moment = moment().endOf('day');


	constructor(public activeModal: NgbActiveModal, public utilities: UtilitiesService, private datePipe: DatePipe, private localStorage: LocalStorageService,private dteEmitidosService: DteEmitidosService,private tokenService: TokenStorageService) {}

	ngOnInit(): void {

		this.locale.format = "DD/MM/YYYY";

		if (this.isSuperAdmin) {
			this.minDate = moment().subtract(2, 'years').startOf('day');
		} else {
			this.minDate = moment().subtract(6, 'months').startOf('day');
		}
		this.dateExportacion.startDate = moment().startOf("day");
		this.dateExportacion.endDate = moment().startOf("day");

		this.empresasSource = JSON.parse(this.localStorage.getEmisores()) as Emisor[];
		this.tipoDteSource = JSON.parse(this.localStorage.getDteTypes()) as TipoDte[];
	}

	detectExportChangeDate(event) {
		this.validDate = true;
		if (event.startDate != null && event.endDate != null) {
		  this.dateExportacion = event;
		  return;
		}
		if (event.target && event.target.value) {
		  const typedValue = event.target.value.trim();
	
		  if (typedValue.includes('-')) {
			const parts = typedValue.split('-').map(p => p.trim());
			if (parts.length === 2) {
			  const startString = parts[0];
			  const endString = parts[1];
			  const startIsValid = moment(startString, this.locale.format, true).isValid();
			  const endIsValid   = moment(endString, this.locale.format, true).isValid();
			  this.validDate = startIsValid && endIsValid;
	  
			  if (this.validDate) {
				this.dateExportacion = {
				  startDate: moment(startString, this.locale.format),
				  endDate:   moment(endString, this.locale.format),
				};
			  }
			} else {
			  this.validDate = false;
			}
		  } else {
			const singleIsValid = moment(typedValue, this.locale.format, true).isValid();
			this.validDate = singleIsValid;
			if (this.validDate) {
			  const date = moment(typedValue, this.locale.format);
			  this.dateExportacion = {
				startDate: date,
				endDate:   date, 
			  };
			}
		  }
		}
	  }

	private showWarning(message: string): Promise<any> {
		return Swal.fire({
			title: 'Advertencia',
			text: message,
			icon: 'warning',
			showCancelButton: true,
			confirmButtonColor: '#3085d6',
			cancelButtonColor: '#d33',
			confirmButtonText: 'Sí, exportar',
			cancelButtonText: 'Cancelar'
		});
	}
	

	onSubmit() {
		if (this.validDate && this.dateExportacion.startDate && this.dateExportacion.endDate) {

			const rangoMeses = this.dateExportacion.endDate.diff(this.dateExportacion.startDate, 'months');
			const limiteMaximoMeses = this.isSuperAdmin ? 24 : 6; // 24 meses (2 años) o 6 meses

			if (rangoMeses > limiteMaximoMeses) {
				Swal.fire({
					icon: 'error',
					title: 'Rango Excesivo',
					html: `Puede exportar en un rango de  ${this.isSuperAdmin ? '24 meses (2 años)' : '6 meses'}.`,
				});
				return;
			}
			
			this.filter.fechaDesde = this.dateExportacion.startDate.format("YYYY-MM-DD");
			this.filter.fechaHasta = this.dateExportacion.endDate.format("YYYY-MM-DD");
			const mostrarMensajeExito = () => {
				Swal.fire({
					icon: 'success',
					title: 'Exportación de documentos',
					text: 'Los documentos se han exportado correctamente',
				}).then(() => {
					this.closeModal();
				});
			};

			if (this.exportType === 'pdf' || this.exportType === 'xml') {
				this.showWarning('La exportación de los documentos puede tardar unos minutos. ¿Desea continuar con la exportación?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						const request = {fromDate: this.filter.fechaDesde,toDate: this.filter.fechaHasta,fileType: this.exportType, EmisorId: this.filter.emisorId};
						this.dteEmitidosService.getZip(request).subscribe({
							next: (blobZip) => {
								const dateOfDownLoad = moment().format('DDMMYYYY');
								const fileName = `documentos_${dateOfDownLoad}_${this.exportType}.zip`;
								FileSaver.saveAs(blobZip, fileName);
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							error: (error) => {
								console.error('Error al exportar PDF/XML:', error);
								this.exportData.emit(false);
							}
						});
					} else {
						this.exportData.emit(false);
					}
				});
			}
			else if (this.getDataFunction != undefined) {
				this.showWarning('La exportación de los documentos puede tardar unos minutos. ¿Desea continuar con la exportación?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						this.getDataFunction(this.filter).subscribe(
							(result) => {
								const elements = result;

								elements.forEach((row) => {
									this.setEmisorToElement(row);
									this.setTipoDteToElement(row);
								});

								if (this.type == 33) {
									this.exportExcelData33(elements);
								} else if (this.type == 110) {
									this.exportExcelData110(elements);
								}
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							(error) => {
								this.exportData.emit(false);
								console.error("Error al exportar:", error);
							}
						);
					} else {
						this.exportData.emit(false);
					}
				});
			}

			else if (this.getPagedDataFunction != undefined) {
				this.showWarning('La exportación de los documentos puede tardar unos minutos. ¿Desea continuar con la exportación?')
				.then((result) => {
					if (result.isConfirmed) {
						this.exportData.emit(true);
						this.getPagedDataFunction(this.filter, this.totalItems).subscribe(
							(result) => {
								const elements = result.data;

								elements.forEach((row) => {
									this.setEmisorToElement(row);
									this.setTipoDteToElement(row);
								});

								if (this.type == 33) {
									this.exportExcelData33(elements);
								} else if (this.type == 110) {
									this.exportExcelData110(elements);
								}
								else if(this.type == 52){
									this.exportExcelData_52(elements);
								}
								else if(this.type == 46){
									this.exportExcelData_46(elements);
								}
								else if(this.type == -1){
									this.exportExcelData_Recibidos(elements);
								}
								this.exportData.emit(false);
								mostrarMensajeExito();
							},
							(error) => {
								this.exportData.emit(false);
								console.error("Error al exportar:", error);
							}
						);
					} else {
						this.exportData.emit(false);
					}
				});
			}
		}
	}

	setEmisorToElement(row: IDte) {
		let empresaAsociada = this.empresasSource.find((Emisor) => Emisor.emisorId == row.emisorId);
		row.emisorAsociado = empresaAsociada;
	}
	setTipoDteToElement(row: IDte) {
		if (row.tipoDteId) {
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.tipoDteId == row.tipoDteId);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
		else if(row.codigoTipoDte){
			let tipoDteAsociado = this.tipoDteSource.find((tipo) => tipo.codigosii == row.codigoTipoDte);
			row.nombreTipoDte = tipoDteAsociado.abreviacion;
		}
	}

	private getOrigenDte(row: DteEmitido): string {
		if (row.importado && row.formaPago !== "Importado") {
		  return "Importado SII";
		} else if (row.importado && row.formaPago === "Importado") {
		  return "Importado Sistema";
		} else {
		  return "SimpleFactura";
		}
	  }
	private getOrigenDteExportacion(row: FacturaExportacion): string {
		if (row.importacionMasivaId && row.formaPago !== "Importado") {
		  return "Importado SII";
		} else if (row.importacionMasivaId && row.formaPago === "Importado") {
		  return "Importado Sistema";
		} else {
		  return "SimpleFactura";
		}
	  }

	
	exportExcelData_Recibidos(arrayToExport: Array<DteRecibido>): void {
//		let RespuestasEstadoAcuseDte = JSON.parse(this.localStorage.getRespuestaEstadoDte()) as RespuestaEstadoDte[];

		let arregloExportar = [];
		arrayToExport.forEach((row) => {			
			let elementToExport = {};
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Proveedor"] = row.rutProveedorDv;
			elementToExport["Razon Social Proveedor"] = row.razonSocialProveedor;
			elementToExport["Fecha de Emisión"] = this.datePipe.transform(row.fechaEmision, "dd/MM/yyyy");
			elementToExport["Fecha de Recepcion"] = this.datePipe.transform(row.fechaRecepcionSii, "dd/MM/yyyy");
			elementToExport["Fecha de Ultimo Procesamiento"] = this.datePipe.transform(row.fechaUltimoProcesamiento, "dd/MM/yyyy");
			elementToExport["Fecha de Vencimiento de Dte"] = this.datePipe.transform(row.fechaVencimiento, "dd/MM/yyyy");
			elementToExport["Fecha de Vencimiento de Acuse"] = this.datePipe.transform(row.fechaVencimientoAcuse, "dd/MM/yyyy");
			elementToExport["Neto"] = row.neto;
			elementToExport["IVA"] = row.iva;
			elementToExport["Exento"] = row.exento;
			elementToExport["Total"] = row.total;
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_recibidos");
	}

	//Factura de compra
	exportExcelData_46(arrayToExport: Array<DteEmitido>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Origen"] = this.getOrigenDte(row);
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Proveedor"] = row.rutReceptor;
			elementToExport["Razon Social Proveedor"] = row.razonSocial;
			elementToExport["Fecha de Emisión"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			if (row.nombreTipoDte === "Nota de Crédito Electrónica") {
				elementToExport["Monto"] = Number(row.total * -1);
			} else {
				elementToExport["Monto"] = row.total;
			}
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	//guía de despacho
	exportExcelData_52(arrayToExport: Array<DteEmitido>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Origen"] = this.getOrigenDte(row);
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Cliente"] = row.rutReceptor;
			elementToExport["Razon Social Cliente"] = row.razonSocial;
			elementToExport["Fecha de Emisión"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			if (row.nombreTipoDte === "Nota de Crédito Electrónica") {
				elementToExport["Monto"] = Number(row.total * -1);
			} else {
				elementToExport["Monto"] = row.total;
			}
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	exportExcelData110(arrayToExport: Array<FacturaExportacion>): void {
		let arregloExportar = [];
		arrayToExport.forEach((row) => {
			let elementToExport = {};
			elementToExport["Tipo DTE"] = row.nombreTipoDte;
			elementToExport["Folio"] = row.folio;
			elementToExport["Emisor"] = row.emisorAsociado.razonSocial;
			elementToExport["Rut Cliente"] = row.rutReceptor;
			elementToExport["Razon Social Cliente"] = row.razonSocial;
			elementToExport["Fecha de Emisión"] = this.datePipe.transform(row.fecha, "dd/MM/yyyy");
			elementToExport["Pais"] = row.territorioDesembarque;
			elementToExport["Puerto Embarque"] = row.nombrePuertoEmbarque;
			elementToExport["Puerto Desembarque"] = row.nombrePuertoDestino;
			elementToExport["Clausula"] = row.clausulaVentaGlosa;
			elementToExport["Modalidad Venta"] = row.modalidadVentaGlosa;
			elementToExport["Moneda"] = row.tipoMoneda;
			elementToExport["Seguro"] = row.seguro;
			elementToExport["Flete"] = row.flete;
			elementToExport["Bienes"] = row.totalValorBienes;
			elementToExport["Monto Total Divisa"] = row.seguro + row.flete + row.totalValorBienes;
			elementToExport["Tipo de Cambio"] = row.tipoCambio;
			elementToExport["Monto Clp"] = row.montoClp;
			elementToExport["Origen"] = this.getOrigenDteExportacion(row);
			arregloExportar.push(elementToExport);
		});
		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	exportExcelData33(arrayToExport: Array<DteEmitido>): void {
		const tiposImpuestos = new Set<string>();
		arrayToExport.forEach((row) => {
			if (row.impuestosDesglosados) {
				row.impuestosDesglosados.forEach((impuesto) => {
					tiposImpuestos.add(impuesto.nombreImp);
				});
			}
		});
		const tiposImpuestosArray = Array.from(tiposImpuestos);
		const encabezados = ["Tipo DTE", "Folio", "Emisor", "Rut Cliente", "Razon Social Cliente", "Fecha de Emisión", "Hora de Emisión", "Neto", "Iva", "Exento", "Impuesto", "Total","Origen"];
		const encabezadosImpuestos = tiposImpuestosArray.map((tipo) => `Impuesto - ${tipo}`);

		const encabezadosFinales = [...encabezados, ...encabezadosImpuestos];

		const arregloExportar = arrayToExport.map((row) => {
			const elementToExport: any = {
				"Tipo DTE": row.nombreTipoDte,
				Folio: row.folio,
				Emisor: row.emisorAsociado?.razonSocial || "",
				"Rut Cliente": row.rutReceptorDv,
				"Razon Social Cliente": row.razonSocial,
				"Fecha de Emisión": this.datePipe.transform(row.fecha, "dd/MM/yyyy"),
				"Hora de Emisión": this.datePipe.transform(row.fechaCreacion, "HH:mm:ss"),
				Neto: row.neto,
				Iva: row.iva,
				Exento: row.exento,
				Impuesto: row.impuestos,
				Total: row.total,
				Origen: this.getOrigenDte(row),
			};

			// Agregar columnas de impuestos dinámicos
			tiposImpuestosArray.forEach((tipo) => {
				const impuesto = row.impuestosDesglosados?.find((im) => im.nombreImp === tipo);
				elementToExport[`Impuesto - ${tipo}`] = impuesto ? impuesto.valor : 0;
			});

			return elementToExport;
		});

		this.utilities.exportAsExcelFile(arregloExportar, "Dte_emitidos");
	}

	

	closeModal() {
		this.activeModal.dismiss("Modal Closed");
	}
}
